import * as React from "react";

import { BaseIcon } from "../Icons/BaseIcon";
import clsxm from "../../lib/clsxm";

interface LinkProps {
  href: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
}

const Link = (props: LinkProps) => {
  return (
    <a
      href={props.href}
      onClick={props.onClick}
      className={clsxm([
        "inline-flex items-center gap-1 text-blue-600 transition duration-240 ease-out",
        "hover:text-blue-800",
        "active:text-black-900",
        "focus:outline-brand-100",
        props.className,
      ])}
    >
      {props.icon ? (
        <BaseIcon className="inline-block leading-none" icon={props.icon} />
      ) : null}
      {props.children}
    </a>
  );
};

export default Link;
